
import { SWRConfiguration, SWRResponse } from "swr";

import { IReturn, GetFormSourceDataStatuses, QuerySourceDataStatusesResponse, Participant, SourceDataStatus } from "@/api/dtos";
import { useMemo } from "react";
import useGet from "@/hooks/api/useGet";

const getData = (response?: SWRResponse<QuerySourceDataStatusesResponse, QuerySourceDataStatusesResponse>) => response?.data?.data;
const getError = (response?: SWRResponse<QuerySourceDataStatusesResponse, QuerySourceDataStatusesResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (response?: SWRResponse<QuerySourceDataStatusesResponse, QuerySourceDataStatusesResponse>) => ({
    idMap: response?.data?.data?.reduce<Record<string, Record<number, Record<string, SourceDataStatus>>>>((a, b) => {
        if (!b?.studyEventOid || !b?.studyEventRepeat || !b?.caseReportFormOid) {
            return a;
        }
        
        if (!a[b.studyEventOid]) {
            a[b.studyEventOid] = {};
        }

        if (!a[b.studyEventOid][b.studyEventRepeat]) {
            a[b.studyEventOid][b.studyEventRepeat] = {};
        }

        a[b.studyEventOid][b.studyEventRepeat][b.caseReportFormOid] = b;

        return a;
    },{})
});

export const useParticipantSourceDataFormStatuses = (participantId?: number, studyEventOid?: string, studyEventRepeat?: number, configuration?: SWRConfiguration | undefined) => {
    const request = useMemo(() => {
        if (!participantId) {
            return undefined;
        }

        return () => {
            return new GetFormSourceDataStatuses({ participantId, studyEventOid, studyEventRepeat });
        }
    }, [participantId, studyEventOid, studyEventRepeat]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useParticipantSourceDataFormStatuses;